
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>希望日</label>
        <datepick v-model="searchForm.model.event_date" :placeholder="'希望日'" @change="search()"></datepick>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <pagination :pager="pager" :callback="search"></pagination>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>まるなげID</th>
          <th>希望日時</th>
          <th>エリア</th>
          <th>人数</th>
          <th>予算</th>
          <th>立候補日時</th>
          <th>立候補店舗名</th>
          <th>立候補メッセージ</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="candidate in candidates" :key="candidate.id">
          <td>{{ candidate.marunage.code }}</td>
          <td>{{ candidate.marunage.event_date | formatDate }} {{ candidate.marunage.event_time }}</td>
          <td>{{ candidate.marunage.area_label }}</td>
          <td>{{ candidate.marunage.people_label }}</td>
          <td>{{ candidate.marunage.price_label }}</td>
          <td>{{ candidate.created_at | formatDatetime }}</td>
          <td>{{ candidate.shop.name }}</td>
          <td>
            <div class="ui green button" @click="showCandidateDetail(candidate)">立候補内容を確認</div>
            <div :id="dialogId(candidate)" class="ui small modal">
              <i class="close icon"></i>
              <div class="header">{{ candidate.shop.name }}</div>
              <div class="scrolling content">
                <candidate-detail :candidate="candidate"></candidate-detail>
              </div>
              <div class="actions">
                <button class="ui cancel button">閉じる</button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
